import React from 'react';
import PropTypes from 'prop-types';
import { StyledCarouselList, StyledCarouselButton } from './Carousel.styles';
import SVGIcon from '../../BuildingBlocks/SVGIcon/SVGIcon';
import { colors } from '../../css';

/* eslint-disable react/jsx-no-bind */
/**
 * PagingDots overwrites the default components used in the pagination of the bottom controls of the Carousel.
 * If we need to change the icon or other functionality of the Carousel dots this is where we would do it.
 */
function PagingDots(props) {
  const { goToSlide, currentSlide, dotColor } = props;

  let roundCurrentSlide = currentSlide;
  if (currentSlide % 1 !== 0) {
    roundCurrentSlide = Math.ceil(currentSlide);
  }

  const getIndexes = () => {
    const { slideCount, slidesToScroll } = props;
    const arr = [];
    for (let i = 0; i < slideCount; i += slidesToScroll) {
      arr.push(i);
    }
    return arr;
  };

  const indexes = getIndexes();

  // Round current slide up if it is a decimal - used when next/prev slide is 'peaking'

  return (
    <StyledCarouselList>
      {indexes.map((index) => (
        <li
          style={{
            listStyleType: 'none',
            display: 'inline-block'
          }}
          key={index}
        >
          <StyledCarouselButton active={roundCurrentSlide === index} onClick={goToSlide.bind(null, index)}>
            <SVGIcon selectedIcon="carousel" iconColor={roundCurrentSlide === index ? dotColor : undefined} />
          </StyledCarouselButton>
        </li>
      ))}
    </StyledCarouselList>
  );
}

PagingDots.propTypes = {
  slideCount: PropTypes.number.isRequired,
  slidesToScroll: PropTypes.number.isRequired,
  goToSlide: PropTypes.func.isRequired,
  currentSlide: PropTypes.number.isRequired,
  dotColor: PropTypes.string
};

PagingDots.defaultProps = {
  dotColor: colors.colorBurgundy
};

export default PagingDots;
